import React, { Component } from "react";
import axios from "axios";
import Media from "react-media";
import ReactGA from "react-ga";
import ToTop from "react-scroll-top";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { Button, Modal, Form, Input, Message } from "semantic-ui-react";
import styled from "styled-components";
import "./styles.css";

import decal from "./library/images/KF2_KFInc_KeyArt_Flats.jpg";
import mrsFoster from "./library/images/MrsFoster.jpg";

import {
  MobileBanner,
  VideoLoop,
  BuyNowLinks,
  SocialLinks,
  BundleTrailer,
  KF2Trailer,
  KFIncursionTrailer,
  Carousel,
  Footer
} from "./LazyLoading";

ReactGA.initialize("UA-384258-17");
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props) {
    super(props);
    const { cookies } = props;

    this.state = {
      day: "",
      month: "",
      year: "",
      age: cookies.get("age") || 0,
      message: "Please enter a valid Date of Birth",
      open: true,
      closeOnEscape: false,
      closeOnDimmerClick: false,
      currentSteamPrice: "",
      currentSteamDiscount: 0
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit() {
    if (this.state.day < 1 || this.state.day > 31) {
      this.setState({ message: "Please enter a valid day" });
    } else if (this.state.month < 1 || this.state.month > 12) {
      this.setState({ message: "Please enter a valid month" });
    } else if (this.state.year < 1900 || this.state.year > 2019) {
      this.setState({ message: "Please enter a valid year" });
    } else {
      const dob = this.state.year + this.state.month + this.state.day;
      const year = Number(dob.substr(0, 4));
      const month = Number(dob.substr(4, 2)) - 1;
      const day = Number(dob.substr(6, 2));
      const today = new Date();
      let age = today.getFullYear() - year;

      if (
        today.getMonth() < month ||
        (today.getMonth() === month && today.getDate() < day)
      ) {
        age--;
      }

      const { cookies } = this.props;
      cookies.set("age", age, { path: "/" });
      this.setState({ age });
      window.location.reload();
    }
  }

  closeConfigShow = (closeOnEscape, closeOnDimmerClick) => () => {
    this.setState({ closeOnEscape, closeOnDimmerClick, open: true });
  };

  close = () => this.setState({ open: false });

  componentDidMount() {
    this.getCurrentSteamPrice();
  }

  getCurrentSteamPrice = async () => {
    try {
      const res = await axios.get(
        "https://cors-anywhere.herokuapp.com/https://store.steampowered.com/api/appdetails?appids=300380&cc=us&filters=price_overview"
      );
      const currentSteamPrice =
        res.data["300380"].data.price_overview.final_formatted;
      const currentSteamDiscount =
        res.data["300380"].data.price_overview.discount_percent;
      this.setState({ currentSteamPrice, currentSteamDiscount });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { open, closeOnEscape, closeOnDimmerClick } = this.state;
    const validAge = this.state.age !== 0 && this.state.age >= 17;
    const modal =
      this.state.age === 0 ? (
        <div>
          <Modal
            basic
            size="large"
            style={{
              textAlign: "center",
              background: "rgba(0, 0, 0, 0.5)",
              borderRadius: "5px"
            }}
            open={open}
            closeOnEscape={closeOnEscape}
            closeOnDimmerClick={closeOnDimmerClick}
            onClose={this.close}
          >
            <Modal.Header style={{ border: "none" }}>
              Warning: Restricted Content
            </Modal.Header>
            <Modal.Content>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field required>
                    <label style={{ color: "white" }}>Day</label>
                    <Input
                      placeholder="DD"
                      name="day"
                      type="number"
                      size="large"
                      value={this.state.day}
                      onChange={this.handleInputChange}
                    />
                  </Form.Field>
                  <Form.Field required>
                    <label style={{ color: "white" }}>Month</label>
                    <Input
                      placeholder="MM"
                      name="month"
                      type="number"
                      size="large"
                      value={this.state.month}
                      onChange={this.handleInputChange}
                    />
                  </Form.Field>
                  <Form.Field required>
                    <label style={{ color: "white" }}>Year</label>
                    <Input
                      placeholder="YYYY"
                      name="year"
                      type="number"
                      size="large"
                      value={this.state.year}
                      onChange={this.handleInputChange}
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
              <Message
                style={{
                  color: "white",
                  textAlign: "center",
                  background: "rgba(0, 0, 0, 0)"
                }}
              >
                <p>{this.state.message}</p>
              </Message>
            </Modal.Content>
            <Modal.Actions
              style={{
                display: "flex",
                justifyContent: "center",
                border: "none"
              }}
            >
              <Button
                onClick={this.handleSubmit}
                positive
                labelPosition="right"
                icon="checkmark"
                content="Check Age"
              />
            </Modal.Actions>
          </Modal>
          <ModalWrapper />
        </div>
      ) : (
        <div>
          <Modal
            basic
            size="large"
            style={{
              textAlign: "center",
              background: "rgba(0, 0, 0, 0.5)",
              borderRadius: "5px"
            }}
            open={open}
            closeOnEscape={closeOnEscape}
            closeOnDimmerClick={closeOnDimmerClick}
            onClose={this.close}
          >
            <Modal.Header style={{ border: "none" }}>
              Restricted Content
            </Modal.Header>
            <Modal.Content>
              <Message
                style={{
                  color: "white",
                  textAlign: "center",
                  background: "rgba(0, 0, 0, 0)"
                }}
              >
                <p>Sorry, you do not have access to this content</p>
              </Message>
            </Modal.Content>
          </Modal>
          <ModalWrapper />
        </div>
      );
    return (
      <div>
        {validAge ? (
          <PageWrapper>
            <React.Fragment>
              <Media query="(max-width: 1024px)">
                {matches => (matches ? <MobileBanner /> : <VideoLoop />)}
              </Media>
              <BuyNowLinks
                currentSteamPrice={this.state.currentSteamPrice}
                currentSteamDiscount={this.state.currentSteamDiscount}
              />
              <SocialLinks />
              <TextWrapper>
                <h2>
                  Killing Floor Double Feature - Coming Soon on PlayStation®4
                  and PlayStation®VR
                </h2>
                <p>
                  Two top games from the Killing Floor Universe for one great
                  price bundled together for your PlayStation®4 and
                  PlayStation®VR console systems.
                </p>
              </TextWrapper>
              <BundleTrailer />
              <TextWrapper>
                <p>
                  The Killing Floor Double Feature also includes the fan
                  favorite Mrs. Foster Playable Character DLC FREE for Killing
                  Floor 2!" *Retail Version Only.
                </p>
              </TextWrapper>
              <ImageWrapper>
                <img src={mrsFoster} alt="Mrs. Foster Sell Sheet" />
              </ImageWrapper>
              <TextWrapper>
                <h2>Bundle Features</h2>
                <h3>Killing Floor 2</h3>
                <ul>
                  <li>
                    6 Player Co-op or solo play with a multitude playable
                    characters to choose from
                  </li>
                  <li>
                    Wield an arsenal of over 80 weapons including assault
                    rifles, brutal melee weapons, historical guns and ‘mad
                    scientist’ weapons
                  </li>
                  <li>Multitue of playable characters</li>
                </ul>
                <h3>Killing Floor: Incursion</h3>
                <ul>
                  <li>
                    Experience a full story-driven campaign in VR as you uncover
                    Horzine’s true intentions
                  </li>
                  <li>Co-op Play with a friend in Story and Holdout modes</li>
                </ul>
              </TextWrapper>
              <ImageWrapper>
                <img src={decal} alt="Killing Floor Double Feature" />
              </ImageWrapper>
              <LogoWrapper>
                <img
                  src="https://cosmic-s3.imgix.net/337c6750-dc77-11e8-85d1-4995d32e5371-killing-floor-2-png.png"
                  alt="Killing Floor 2 Logo"
                  onClick={() =>
                    (window.location = "https://killingfloor2.com/")
                  }
                />
              </LogoWrapper>
              <TextWrapper>
                <p>
                  In KILLING FLOOR 2, players descend into continental Europe
                  after it has been overrun by horrific, murderous clones called
                  Zeds that were created by rogue elements of the Horzine
                  Corporation. The Zed outbreak caused by Horzine’s failed
                  experiments has quickly spread with unstoppable momentum,
                  paralyzing the European Union. Only a month ago, the first Zed
                  outbreak from the original KILLING FLOOR ripped through
                  London; now the Zeds are everywhere. Civilization is in
                  disarray, communication networks have failed, governments have
                  collapsed, and military forces have been systematically
                  eradicated. The people of Europe are now focused on
                  self-preservation, the lucky few who survived having gone into
                  hiding.
                </p>
              </TextWrapper>
              <KF2Trailer />
              <TextWrapper>
                <p>
                  But not all have given up hope; a motley group of civilians,
                  soldiers, and mercenaries have banded together to fight the
                  Zed outbreaks from bases across Europe. When an outbreak is
                  detected, the players are sent into Zed-laden hot zones to
                  exterminate all threats using whatever means necessary.
                  Welcome to the Killing Floor.
                </p>
                <p>
                  For more information visit the{" "}
                  <a href="https://killingfloor2.com">
                    official Killing Floor 2 website
                  </a>
                  .
                </p>
              </TextWrapper>
              <LogoWrapper>
                <img
                  style={{ padding: "20px 0" }}
                  src="https://cosmic-s3.imgix.net/cef7a160-e201-11e8-90a6-838a67cee640-KF_Incursion_Logo.png"
                  alt="Killing Floor: Incursion Logo"
                  onClick={() =>
                    (window.location =
                      "https://www.tripwireinteractive.com/#/killing-floor-incursion")
                  }
                />
              </LogoWrapper>
              <TextWrapper>
                <p>
                  As a trainee of the elite Horzine Security Forces, you’ve been
                  implanted into a neuro-active simulation where you fight
                  hordes of sci-fi monsters with bullets and blades, but your
                  true purpose here seems shrouded in mystery…
                </p>
              </TextWrapper>
              <KFIncursionTrailer />
              <TextWrapper>
                <p>
                  Killing Floor: Incursion will offer intense and unmatched
                  cooperative VR shooter combat in a compelling universe.
                  Combining elements of combat, adventure, survival horror and
                  exploration, players will experience a full narrative campaign
                  experience as they infiltrate the Horzine central computer.
                </p>
                <p>
                  For more information visit the{" "}
                  <a href="https://tripwireinteractive.com/#/killing-floor-incursion">
                    official Killing Floor: Incursion website
                  </a>
                  .
                </p>
              </TextWrapper>
              <TextWrapper>
                <h2>
                  Read what people are saying about Killing Floor 2 and Killing
                  Floor: Incursion...
                </h2>
              </TextWrapper>
              <Carousel />
              <Footer />
              <ToTop hideAt={160} position="top" />
            </React.Fragment>
          </PageWrapper>
        ) : (
          modal
        )}
      </div>
    );
  }
}

export default withCookies(App);

const ModalWrapper = styled.div`
  height: 100vh;
  background-image: url("https://cosmic-s3.imgix.net/f4a84ef0-ec06-11e8-b90b-cb15cd011e77-Screen1.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

const PageWrapper = styled.div`
  h1,
  h2 {
    font-family: "BICUBIK", sans-serif;
  }
`;

const TextWrapper = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  h2 {
    font-size: 24px;
    letter-spacing: 3px;
    text-align: center;
    color: #fde704;
    text-shadow: 1px 1px #000000;
    padding: 5vh 0;
  }

  h3 {
    color: #fde704;
    text-shadow: 1px 1px black;
    text-align: left;
    padding: 5px;
    font-size: 18px;
  }

  a {
    color: #fde704;
    text-decoration: none !important;
  }

  a:hover {
    color: #fde704 !important;
    text-decoration: underline !important;
  }

  p,
  li {
    text-shadow: 1px 1px black;
    font-size: 16px;
    color: white;
    text-align: justify;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    margin-bottom: 20px;
    padding: 0 5vw;

    h2 {
      font-size: 21px;
      letter-spacing: 2px;
    }

    h3 {
      font-size: 15px !important;
    }

    p,
    li {
      text-align: left;
      font-size: 14px;
    }
  }
`;

const ImageWrapper = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  img {
    width: 100%;
    height: 100%;
    box-shadow: 0 5px 5px -3px black;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    padding: 0 5vw;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20vw;
  margin: 10vh 0 5vh 0;
  background: #4b4b4b;
  background: -webkit-radial-gradient(center, #4b4b4b, #1f1f1f);
  background: -moz-radial-gradient(center, #4b4b4b, #1f1f1f);
  background: radial-gradient(ellipse at center, #4b4b4b, #1f1f1f);

  img {
    width: 50%;
    height: 50%;
  }

  img:hover {
    cursor: pointer;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 800px) {
    img {
      width: 75%;
      height: 75%;
    }
  }

  @media (max-width: 650px) {
    padding: 0 5vw;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;
